import { CosmosFlag } from "@cosmos/web/react"

// Returns the flag image asset matching the country code
export default function CountryFlag({ countryCode }) {
    return countryCode ? <CosmosFlag code={countryCode} alt={countryCode} loading="lazy"></CosmosFlag> : null 
}